import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import DialogModal from "../../common/DialogModal";
import { addCommas } from "../../../utils/utils";
import { isLetterCostPerOrder, isKLFollowCall } from "../../../utils/userUtils";
import { isEnableFollowCallHouseList } from "../../../utils/userOptionUtils";
import Button from "../../Parts/Button";

const styles = () => ({
  paper: {
    maxHeight: "unset",
  },

  contentContainer: {
    padding: "43px 45px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "500px",
    boxSizing: "border-box",
    background: "#FFFFFF",
    textAlign: "left",
  },

  row: {
    marginBottom: "22px",
    width: "100%",
    boxSizing: "border-box",
  },

  sectionTitle: {
    fontSize: "16px",
    marginBottom: "14px",
    fontWeight: "bold",
    padding: "8px 0px 11px 0px",
    borderBottom: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    textAlign: "left",
  },

  text: {
    margin: 0,
    padding: 0,
    fontSize: "16px",
    maxWidth: "410px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  note: {
    display: "block",
    fontSize: "12px",
    margin: 0,
    padding: 0,
  },

  noteSection: {
    borderRadius: "2px",
    backgroundColor: "#F4F6F9",
    width: "100%",
    padding: "16px",
    boxSizing: "border-box",
    marginBottom: "22px",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
    marginTop: "50px",
  },
});

class ConfirmOrderDialog extends React.Component {
  renderConfirmOrderPanel() {
    const {
      classes,
      toggleDialog,
      letterCount,
      trackingUrl,
      orderContact,
      disableButton,
      shintenMarkFlag,
      registeredLetterFlag,
      originalLetterFormatFlag,
      user,
      salesforce_sync_flag,
      followCallFlag,
      isExe,
    } = this.props;

    let unitPrice, totalCost;
    let registeredUnitPrice = '¥0';

    // BDRプランは料金を表示しない
    if (
      isLetterCostPerOrder(user) &&
      !isNaN(user.active_plan.letter_unit_price)
    ) {
      unitPrice = `¥${addCommas(user.active_plan.letter_unit_price)}`;
      totalCost = user.active_plan.letter_unit_price;

      // 独自フォーマットが選択された場合の単価は独自フォーマットの単価にする
      if (originalLetterFormatFlag && user && user.original_letter_format_flag && !isNaN(user.original_letter_format_unit_price) && user.original_letter_format_unit_price) {
        unitPrice = `¥${addCommas(user.original_letter_format_unit_price)}`;
        totalCost = user.original_letter_format_unit_price;
      }

      // 単価に書留サービスの料金を加算する
      if (registeredLetterFlag && user && user.registered_letter_flag && !isNaN(user.registered_unit_price) && user.registered_unit_price) {
        registeredUnitPrice = `¥${addCommas(user.registered_unit_price)}`;
        totalCost = totalCost + user.registered_unit_price;
      }

      totalCost = totalCost * letterCount;
    }

    // フォローコールの欄を表示するかどうか
    const isFollowCallVisible = (isExe && isKLFollowCall(user)) || (!isExe && isEnableFollowCallHouseList(user));

    return (
      <div>
        <Typography variant="display1" style={{ marginBottom: "48px" }}>
          注文を送信します。よろしいですか？
        </Typography>

        <div className={classes.row}>
          <div className={classes.sectionTitle}>注文担当者</div>
          <p className={classes.text}>
            {orderContact.length > 0 ? orderContact[0].name : "未設定"}
          </p>
        </div>

        <div className={classes.row}>
          <div className={classes.sectionTitle}>送付部数</div>
          <p className={classes.text}>{letterCount}部</p>
        </div>

        {(isFollowCallVisible) && (
          <div className={classes.row}>
            <div className={classes.sectionTitle}>フォローコール</div>
            <p className={classes.text}>
              {!followCallFlag ? "依頼しない" : '依頼する'}
            </p>
            {!followCallFlag && (
              <small className={classes.note}>
                ※確定すると、後からフォローコールを依頼することはできません
              </small>
            )}
          </div>
        )}

        <div className={classes.row}>
          <div className={classes.sectionTitle}>QRコードトラッキング</div>
          <p className={classes.text}>
            {!trackingUrl ? "未設定" : `設定済み ${trackingUrl}`}
          </p>
        </div>

        <div className={classes.row}>
          <div className={classes.sectionTitle}>親展マーク</div>
          <p className={classes.text}>{shintenMarkFlag ? "あり" : "なし"}</p>
        </div>

        {!!this.props.user && !!this.props.user.original_letter_format_flag && (
          <div className={classes.row}>
            <div className={classes.sectionTitle}>レターフォーマット</div>
            <p className={classes.text}>{originalLetterFormatFlag ? "別途納品したレターフォーマットを利用する" : "キーマンレターのレターフォーマットを利用する"}</p>
          </div>
        )}

        {!!this.props.user && !!this.props.user.registered_letter_flag && (
          <div className={classes.row}>
            <div className={classes.sectionTitle}>書留サービス</div>
            <p className={classes.text}>{registeredLetterFlag ? "利用する" : "利用しない"}</p>
          </div>
        )}

        {unitPrice && (
          <div className={classes.row}>
            <div className={classes.sectionTitle}>単価</div>
            <p className={classes.text}>{unitPrice}</p>
          </div>
        )}

        {unitPrice && registeredUnitPrice && !!this.props.user.registered_letter_flag && registeredLetterFlag && (
          <div className={classes.row}>
            <div className={classes.sectionTitle}>書留サービス単価</div>
            <p className={classes.text}>{registeredUnitPrice}</p>
          </div>
        )}

        {totalCost && (
          <div className={classes.row}>
            <div className={classes.sectionTitle}>料金</div>
            <p className={classes.text}>{`¥${addCommas(totalCost)} (税別)`}</p>
            <small className={classes.note}>
              ※用紙代、切手代、印刷代、送料すべてを含んだ合計金額です
            </small>
          </div>
        )}

        <div className={classes.row}>
          <div className={classes.sectionTitle}>発送予定日</div>
          <p className={classes.text}>
            {this.props.shippingScheduledAt.format("YYYY年MM月DD日")}
          </p>
          <small className={classes.note}>
            ※天候・交通状況により前後します
          </small>
        </div>

        {!!this.props.user.can_select_order_scheduled_date && (
          <div className={classes.row}>
            <div className={classes.sectionTitle}>注文予定日</div>
            <p className={classes.text}>
              {this.props.orderScheduledAt.format("YYYY年MM月DD日")}
            </p>
          </div>
        )}

        <div className={classes.noteSection}>
          <p className={classes.note}>
            ※事前に印刷データを確認したい場合は、ご注文後3時間以内に右下のチャットよりお問い合わせください。なお、事前確認される場合は、入稿データが確定してからの印刷となりますので、必ずしも表示の発送予定日通りに配送されないことをあらかじめご了承ください。
          </p>
          <p className={classes.note}>
            ※自社リストの宛先をご利用の場合に、データに不備がございますと必ずしも表示の発送予定日通りに配送されないことをあらかじめご了承ください。
          </p>
          <p className={classes.note}>
            ※ご注文後3時間を超えてのキャンセルはできませんのであらかじめご了承ください。
          </p>
          <p className={classes.note}>
            ※3時間を超えてどうしてもキャンセルされたい場合は画面右下のチャットよりお問い合わせください。タイミングにより発送が避けられない可能性もございますので予めご了承くださいませ。また、ご注文後3時間を超えてのキャンセルの場合、ご料金は発生いたしますので合わせてご了承くださいませ。
          </p>
        </div>

        <div className={classes.row}>
          <div className={classes.sectionTitle}>Salesforceに同期</div>
          <p className={classes.text}>
            {salesforce_sync_flag ? "同期する" : "同期しない"}
          </p>
        </div>

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            size="large"
            text="キャンセル"
            type="ghost"
          ></Button>
          <Button
            handleClickButton={this.props.handleOrder}
            size="large"
            text="注文を送信"
            disabled={disableButton}
            loading={this.props.isPosting}
          ></Button>
        </div>
      </div>
    );
  }

  render() {
    const { classes, toggleDialog, isOpen } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        {this.renderConfirmOrderPanel()}
      </DialogModal>
    );
  }
}

ConfirmOrderDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isExe: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  handleOrder: PropTypes.func.isRequired,
  isPosting: PropTypes.bool,
  disableButton: PropTypes.bool,
  letterCount: PropTypes.number,
  trackingUrl: PropTypes.string,
  orderContact: PropTypes.array,
  shintenMarkFlag: PropTypes.bool,
  registeredLetterFlag: PropTypes.bool,
  originalLetterFormatFlag: PropTypes.bool,
  user: PropTypes.object,
  salesforce_sync_flag: PropTypes.bool,
  followCallFlag: PropTypes.bool,
  shippingScheduledAt: PropTypes.object,
  orderScheduledAt: PropTypes.object,
};

export default withStyles(styles)(ConfirmOrderDialog);



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/ConfirmOrderDialog.jsx